import { useMemo } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import axios from 'axios'

const fetchCollectionItems = async ({ pageParam = 1, slug }) => {
  const { data } = await axios.get(`/products/${slug}/collection_items`, {
    params: { page: pageParam },
  })
  return data
}

const useCollectionItems = (initialProducts, slug, hasMoreInitially) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ['collectionItems', slug],
    queryFn: ({ pageParam }) => fetchCollectionItems({ pageParam, slug }),
    getNextPageParam: (lastPage, allPages) => (lastPage.next ? allPages.length + 1 : undefined),
    initialData: {
      pages: [{ products: initialProducts, next: hasMoreInitially }],
      pageParams: [1],
    },
    staleTime: 15 * 60 * 1000,
    enabled: false,
  })

  const products = useMemo(
    () => data?.pages?.flatMap((page) => page.products) ?? initialProducts,
    [data?.pages, initialProducts]
  )

  return { products, fetchNextPage, hasNextPage, isFetchingNextPage }
}

export default useCollectionItems
